export const FILTER_NAME = 'retailer-unit-report'
